export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
export const validatePhoneNumber = (phone) => {
    const numbers = phone.replace(/\D/g, '');
    return numbers.length === 11;
};
export const isCpf = (value) => {
    if (!value)
        return false;
    if (isMaskedCpf(value)) {
        return true;
    }
    const identifier = value.replace(/\D/g, '');
    if (identifier.toString().length === 11) {
        const number = identifier.toString().slice(0, -2);
        const firstValidationDigit = identifier.toString()[9];
        const secondValidationDigit = identifier.toString()[10];
        if (checkCpfValidationDigit(number, firstValidationDigit) &&
            checkCpfValidationDigit(number + firstValidationDigit, secondValidationDigit)) {
            return true;
        }
        return false;
    }
    return false;
};
export const checkCpfValidationDigit = (identifier, validationDigit) => {
    const number = identifier
        .split('')
        .map((item, i) => parseInt(item) * (identifier.length + 1 - i))
        .reduce((x, y) => x + y, 0);
    let result = 11 - (number % 11);
    if (result === 10 || result === 11) {
        result = 0;
    }
    return result.toString() === validationDigit;
};
export const checkCnpjValidationDigit = (identifier, validationDigit) => {
    const number = identifier
        .split('')
        .reverse()
        .map((item, i) => ((i % 8) + 2) * parseInt(item, 10))
        .reduce((x, y) => x + y, 0);
    let result = number % 11;
    if (result < 2) {
        result = 0;
    }
    else {
        result = 11 - result;
    }
    return result.toString() === validationDigit;
};
export const isCnpj = (value) => {
    if (!value)
        return false;
    if (isMaskedCnpj(value)) {
        return true;
    }
    const identifier = value.replace(/\D/g, '');
    if (identifier.toString().length === 14) {
        const number = identifier.toString().slice(0, -2);
        const firstValidationDigit = identifier.toString()[12];
        const secondValidationDigit = identifier.toString()[13];
        if (checkCnpjValidationDigit(number, firstValidationDigit) &&
            checkCnpjValidationDigit(number + firstValidationDigit, secondValidationDigit)) {
            return true;
        }
        return false;
    }
    return false;
};
export const isMaskedCpf = (value) => {
    return value.length === 11 && value.includes('*');
};
export const isMaskedCnpj = (value) => {
    return value.length === 14 && value.includes('*');
};
